import React from 'react';
import Navbar from '../components/Navbar';
import { useNavigate, useLocation } from 'react-router-dom';
import { Check, Star, Zap, ShieldCheck } from 'lucide-react';
import './Pricing.css';

function Pricing() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const isFromChat = searchParams.get('source') === 'chat';
    const highlightPlan = searchParams.get('plan');

    React.useEffect(() => {
        if (highlightPlan === 'basic') {
            const basicCard = document.querySelector('.pricing-card:not(.popular)');
            if (basicCard) {
                basicCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                basicCard.classList.add('highlight-pulse');
            }
        }
    }, [highlightPlan]);

    const plans = [
        {
            name: '月額プラン',
            price: '¥14,999',
            period: '/月',
            description: '毎月のスピリチュアルな対話に最適です',
            features: [
                '月間30回の神聖なチャット',
                '会話履歴の保存（履歴）',
                '全700以上の聖句(シュローカ)へのアクセス',
                'パーソナライズされた導き',
                '24時間365日の利用可能'
            ],
            buttonText: '今すぐ始める',
            isPopular: false,
            color: 'var(--blue-glow)',
            plan_id: 'monthly_30'
        },
        {
            name: 'プレミアムプラン',
            price: '¥89,999',
            period: '/年',
            description: '最高の体験を求める方のための年間プランです',
            features: [
                '年間360回の神聖なチャット',
                '月額プランの全機能',
                '優先的な音声生成',
                '会話履歴の保存（履歴）',
                '優先的なサポート'
            ],
            buttonText: '最も選ばれています',
            isPopular: true,
            color: 'var(--accent-glow)',
            plan_id: 'premium_30_yearly'
        }
    ];
    
    const couponNudge = {
        code: 'KRISHNA3999',
        message: '特別オファー: クーポン KRISHNA3999 を適用して、月額プランがわずか ¥3999 に！',
        buttonText: '今すぐ適用'
    };

    const [showCoupon, setShowCoupon] = React.useState(true);

    return (
        <div className="pricing-page">
            <Navbar />
            
            {/* Floating Coupon Notification */}
            {showCoupon && (
                <div className="floating-coupon-banner">
                    <button className="close-coupon" onClick={() => setShowCoupon(false)}>×</button>
                    <div className="coupon-content">
                        <div className="coupon-header">
                            <span className="coupon-gift-icon">🎁</span>
                            <span className="coupon-badge-mini">期間限定</span>
                        </div>
                        <span className="coupon-message">{couponNudge.message}</span>
                    </div>
                </div>
            )}

            <div className="pricing-container container">
                <header className="pricing-header">
                    <div className="pricing-badge">
                        <Zap size={14} />
                        <span>PRICING</span>
                    </div>
                    <h1 className="pricing-title">
                        魂の <span className="gradient-text-animated">旅を選択</span>
                    </h1>
                    <p className="pricing-subtitle">
                        あなたのニーズに合わせた最適なプランで、<br />
                        内なる平和と精神的な成長への投資を始めましょう。
                    </p>

                    {isFromChat && (
                        <div className="chat-upgrade-notice">
                            <div className="notice-icon">✨</div>
                            <div className="notice-text">
                                <strong>制限に達しました:</strong> 
                                チャットを続けるにはプランを選択してください。
                            </div>
                        </div>
                    )}
                </header>

                <div className="pricing-grid">
                    {plans.map((plan, index) => (
                        <div
                            key={index}
                            className={`pricing-card ${plan.isPopular ? 'popular' : ''}`}
                        >
                            {plan.isPopular && <div className="popular-badge">一番人気</div>}

                            <div className="plan-name">{plan.name}</div>

                            <div className="plan-price">
                                <span className="currency">{plan.price}</span>
                                <span className="period">{plan.period}</span>
                            </div>

                            <p className="plan-description">{plan.description}</p>

                            <div className="plan-features">
                                {plan.features.map((feature, fIndex) => (
                                    <div key={fIndex} className="feature-item">
                                        <div className="check-icon">
                                            <Check size={16} />
                                        </div>
                                        <span>{feature}</span>
                                    </div>
                                ))}
                            </div>

                            <button
                                className={`plan-button ${plan.isPopular ? 'btn-premium-primary' : 'btn-premium-secondary'}`}
                                onClick={() => navigate('/checkout', { state: { plan } })}
                            >
                                {plan.buttonText}
                            </button>
                        </div>
                    ))}
                </div>

                <div className="pricing-trust">
                    <div className="trust-item">
                        <ShieldCheck size={24} />
                        <span>安全な決済</span>
                    </div>
                    <div className="trust-item">
                        <Star size={24} />
                        <span>満足度 100%</span>
                    </div>
                    <div className="trust-item">
                        <Zap size={24} />
                        <span>即時アクセス</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Pricing;
